<template>
  <div class="aio-machine-setting h100">
    <div class="h100 y-auto">
      <div class="box flex flex-cross--center">
        <span id="span_huacdvf048" class="title fs20 color-0">{{
          $t('cuttingDock.aioMachineSetting.outputFile')
        }}</span>
        <a-switch
          default-checked
          v-model="formData.enable_integration_device"
          id="engraving_setting_aioMachine_enable_integration_device_switch"
        ></a-switch>
        <i id="i_8fn4k58ln7" style="margin-left: 20px; color: #f00">{{
          $t('cuttingDock.aioMachineSetting.outputFileTips')
        }}</i>
      </div>
      <div class="box flex" v-if="formData.enable_integration_device">
        <span id="span_cfebpp9hkn" class="title">{{
          $t('cuttingDock.aioMachineSetting.fileType')
        }}</span>
        <el-select
          v-model="formData.yitiji_machine_name"
          :placeholder="$t('cuttingDock.aioMachineSetting.select')"
          size="small"
          class="select-warp"
          :popper-append-to-body="false"
          filterable
          id="engraving_setting_aioMachine_yitiji_machine_name_select"
          @change="handleChangeOneMac"
        >
          <el-option
            v-for="(item, index) in aioOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :id="`engraving_setting_aioMachine_yitiji_machine_name_option_${index}`"
            class="select-option"
          >
          </el-option>
        </el-select>
        <div class="ml20" v-show="isJidong">
          <div>
            <!-- 对接需开启以下功能 -->
            {{ t('openFunction') }}
          </div>
          <div>
            <!-- 开启雕刻机 -->
            1、{{ t('openCarving') }}
            <span style="color: #f00">
              <!-- XY轴互换功能 -->
              {{ t('xyReverseFunction') }}
            </span>
          </div>
          <div>
            <!-- 雕刻机工位起始点设置为 -->
            2、{{ t('carvingStartSet') }}
            <span style="color: #f00">
              <!-- 右上角 -->
              {{ t('rightTop') }}
            </span>
          </div>
          <div>
            <!-- 雕刻机正面再修边值调整为 -->
            3、{{ t('carvingEdgeSet') }}
            <span style="color: #f00">
              <!-- 与总修边值相同 -->
              {{ t('finalEdgeSame') }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="box"
        v-if="isDiameterShow && formData.enable_integration_device"
      >
        <span id="span_a9iduj6s0h" class="title">{{
          $t('cuttingDock.aioMachineSetting.diameter')
        }}</span>
        <a-input
          @dragover="handleDragOver($event)"
          id="engraving_trimmingKnifeDiameter_input"
          v-model="formData.trimming_knife_diameter"
          placeholder=""
          @input="handleInputChange"
        />
        mm
      </div>
      <div class="com_code" v-show="formData.enable_integration_device">
        <span class="mr10">
          <!--显示数据样例  -->
          {{ t('showDataTemp') }}
        </span>
        <a-checkbox v-model="formData.is_display_sample" />
        <div
          class="mt20 bolder flex flex-dir--top"
          v-if="formData.is_display_sample"
          id="engraving_isDisplaySample_checkbox"
        >
          <span class="bold color-0 fs16">
            <!-- 数据样例 -->
            {{ t('dataTemp') }}
          </span>
          <DockFiveSixSample
            :file-type="fileType"
            :ariMachine="true"
            :modelSetting="modelSetting"
          />
        </div>
      </div>
      <!-- 开启输出一体机且有Z扣加工权限且开启anc文件加工 才展示该设置 -->
      <div
        class="box mt20"
        v-show="
          formData.enable_integration_device &&
          isIrregularMillingPermission &&
          (formData.process_anc_in_front || formData.process_anc_in_back)
        "
      >
        <span class="label-title">
          {{ $translateLang('自定义铣孔铣槽/内部异形切割方向') }}
        </span>
        <a-switch v-model="formData.aio_clock_dir_switch.enable" />
      </div>
      <div
        class="box"
        v-show="
          formData.enable_integration_device &&
          formData.aio_clock_dir_switch.enable &&
          isIrregularMillingPermission &&
          (formData.process_anc_in_front || formData.process_anc_in_back)
        "
      >
        <span class="label-title"> {{ $translateLang('铣孔铣槽方向') }} </span>
        <a-radio-group
          v-model="formData.aio_clock_dir_switch.mill_hole_slot_dir"
        >
          <a-radio value="顺时针">{{ $translateLang('顺时针') }}</a-radio>
          <a-radio value="逆时针">{{ $translateLang('逆时针') }}</a-radio>
        </a-radio-group>
      </div>
      <div
        class="box"
        v-show="
          formData.enable_integration_device &&
          formData.aio_clock_dir_switch.enable &&
          isIrregularMillingPermission &&
          (formData.process_anc_in_front || formData.process_anc_in_back)
        "
      >
        <span class="label-title">
          {{ $translateLang('内部异形切割方向') }}
        </span>
        <a-radio-group
          v-model="formData.aio_clock_dir_switch.cut_internal_curve_dir"
        >
          <a-radio value="顺时针">{{ $translateLang('顺时针') }}</a-radio>
          <a-radio value="逆时针">{{ $translateLang('逆时针') }}</a-radio>
        </a-radio-group>
      </div>
      <div
        v-show="
          formData.enable_integration_device &&
          (formData.process_anc_in_front || formData.process_anc_in_back)
        "
      >
        <div class="operation-btn flex flex-cross--center mt20">
          <a-button
            @click="handleAddNewKnife"
            class="mr12"
            id="aio_setting_knife_table_add_row"
          >
            <!-- 插入行 -->
            {{ kt('insert') }}
          </a-button>
          <a-button
            @click="handleDeleteKnife"
            class="danger-btn"
            id="aio_setting_knife_table_delete_row"
          >
            <!-- 删除行 -->
            {{ kt('delete') }}
          </a-button>
        </div>
        <div class="main-table mt20">
          <el-table
            :key="tableKey"
            :data="formData.anc_setting.knives"
            :row-style="changeStyle"
            :cell-style="columnStyle"
            :header-cell-style="headerStyle"
            :header-row-style="headerRowStyle"
            @row-click="choseKnife"
            :row-class-name="tableRowClassName"
            :cell-class-name="tableCellClassName"
            @cell-click="cellClick"
            :max-height="340"
            class="w100"
          >
            <el-table-column
              v-for="(knife, indexs) in computedKnivesColumns"
              :key="indexs + '1'"
              :label="$t(knife.label)"
              :prop="knife.props"
              :width="knife.width"
              :fixed="[0, 1, 2].includes(indexs)"
            >
              <template slot="header" v-if="knife.props == 'type'">
                <div class="flex flex-cross--center">
                  <span id="span_orlkcndaxn">{{ $translateLang('类型') }}</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="bottom-start"
                  >
                    <div id="div_z8u8wz15sf" slot="content">
                      {{
                        $translateLang(
                          '设置刀具类型后孔槽会匹配对应类型的刀具进行加工'
                        )
                      }}
                    </div>
                    <img
                      src="@/assets/icon/questionMark.png"
                      alt=""
                      style="width: 17px; height: 17px; margin-left: 5px"
                    />
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div v-if="knife.props === 'use'" class="knife-purpose">
                  <a-checkbox-group
                    v-model="scope.row.use"
                    @change="handleUseChange(scope.row)"
                  >
                    <a-checkbox
                      value="holeable"
                      class="mb10 mr8"
                      :id="`engraving_setting_knife_table_${scope.row.index}_use_holeable_checkbox`"
                      :disabled="!['dill', 'mill'].includes(scope.row.type)"
                    >
                      <span
                        style="margin: 0"
                        :id="`engraving_setting_knife_table_${scope.row.index}_use_holeable_checkbox_label`"
                      >
                        <!-- 打孔 -->
                        {{ t('drillHole') }}
                      </span>
                    </a-checkbox>
                    <a-checkbox
                      value="slotable"
                      :id="`engraving_setting_knife_table_${scope.row.index}_use_slotable_checkbox`"
                      :disabled="scope.row.type != 'mill'"
                    >
                      <span
                        style="margin: 0"
                        :id="`engraving_setting_knife_table_${scope.row.index}_use_slotable_checkbox_label`"
                      >
                        <!-- 拉槽 -->
                        {{ t('pullTrough') }}
                      </span>
                    </a-checkbox>
                    <a-checkbox
                      value="trim_able"
                      :id="`engraving_setting_knife_table_${scope.row.index}_use_trimable_checkbox`"
                      :disabled="scope.row.type !== 'mill'"
                    >
                      <span
                        style="margin: 0"
                        :id="`engraving_setting_knife_table_${scope.row.index}_use_trimable_checkbox_label`"
                        >{{ $translateLang('修边') }}</span
                      >
                    </a-checkbox>
                    <a-checkbox
                      value="irregular_milling"
                      :id="`engraving_setting_knife_table_${scope.row.index}_use_irregularMilling_checkbox`"
                      :disabled="scope.row.type !== 'mill'"
                      v-if="isIrregularMillingPermission"
                    >
                      <span
                        style="margin: 0"
                        :id="`engraving_setting_knife_table_${scope.row.index}_use_irregularMilling_checkbox_label`"
                        >{{ $translateLang('铣异形') }}</span
                      >
                    </a-checkbox>
                  </a-checkbox-group>
                </div>
                <div v-else-if="knife.props == 'type'">
                  <a-select
                    v-model="scope.row.type"
                    :id="`engraving_setting_knife_table_${scope.row.index}_type_select`"
                    style="width: 100px"
                    @change="handleChangeKnifeType($event, scope.row)"
                  >
                    <a-select-option
                      v-for="item in knifeTypeOptions"
                      :key="`${item.value}_${scope.row.index}`"
                      :value="item.value"
                      :title="item.label"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div
                  v-else-if="
                    scope.row.index === rowIndex &&
                    scope.column.index === columnIndex &&
                    knife.props !== 'type' &&
                    knife.props !== 'use'
                  "
                >
                  <el-input
                    v-model="scope.row[knife.props]"
                    ref="editInput"
                    type="textarea"
                    size="mini"
                    resize="none"
                    :disabled="
                      !scope.row?.type?.includes('obliqueDrill') &&
                      ['axis_offset', 'arc_radius'].includes(knife.props)
                    "
                    autosize
                    @blur="inputBlur(scope.row, knife.props)"
                    @change="inputBlur(scope.row, knife.props)"
                    @input="
                      handleInputCheck(scope.row, knife.props, knife.isCheck)
                    "
                    :id="`engraving_setting_knife_table_${scope.row.index}_${knife.props}_input`"
                  />
                </div>
                <div
                  class="knives_type"
                  style="white-space: pre-line"
                  v-else-if="
                    knife.props !== 'desc' &&
                    knife.props !== 'type' &&
                    knife.props !== 'use'
                  "
                  :id="`engraving_setting_knife_table_${scope.row.index}_${knife.props}`"
                >
                  {{ scope.row[knife.props] }}
                  <span
                    :class="[
                      'iconfont',
                      'icon-revise',
                      { 'icon-revise-show': scope.row[knife.props] },
                    ]"
                    style="color: #18a8c7"
                  ></span>
                </div>
                <div class="knives_type" style="white-space: pre-line" v-else>
                  {{ scope.row[knife.props] }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-area flex mt20">
          <div class="mr20 flex flex-dir--top">
            <span>
              <!-- 程序开始代码 -->
              {{ t('beginCode') }}：
            </span>
            <a-textarea
              v-model="formData.anc_setting.anc_begin_code"
              id="aio_setting_oddBeginCode_textarea"
              placeholder="输入程序开始代码"
              :maxLength="200"
              style="width: 380px; height: 100px"
              @focus="markTextareaSelection($event, 'anc_begin_code')"
              @drop="handleTextareaDrop($event, 'anc_begin_code')"
            ></a-textarea>
            <div class="textarea-length align-right">
              {{ formData.oddBeginCode?.length ?? 0 }}/200
            </div>
          </div>
          <div class="flex flex-dir--top">
            <span>
              <!-- 程序结束代码 -->
              {{ t('endCode') }}：
            </span>
            <a-textarea
              v-model="formData.anc_setting.anc_end_code"
              id="engraving_setting_evenBeginCode_textarea"
              placeholder="输入程序结束代码"
              :maxLength="200"
              style="width: 380px; height: 100px"
              @focus="markTextareaSelection($event, 'anc_end_code')"
              @drop="handleTextareaDrop($event, 'anc_end_code')"
            ></a-textarea>
            <div class="textarea-length align-right">
              {{ formData.evenBeginCode?.length ?? 0 }}/200
            </div>
          </div>
          <div class="ml20">
            <DataTagPool
              type="labelNameShow"
              :tagList="[{ title: '', arr: ancFileList }]"
              :dropData.sync="dropData"
              @selectChange="selectChange"
            ></DataTagPool>
          </div>
        </div>
      </div>

      <!-- 使用所有一体机的设置 -->
      <div v-show="formData.enable_integration_device" class="common-setting">
        <!-- 孔槽避让夹手位置 -->
        <div class="duck-clamp-hand">
          <div class="item">
            <NewContent :is-new-content="false"
              ><span id="span_6p5822sud1" class="label">{{
                $translateLang('孔槽避让夹手位置')
              }}</span></NewContent
            >
            <a-switch
              v-model="formData.aio_fixture_setting.aio_avoid_fixture"
              @change="handleChangeclampHandStatus"
            />
          </div>
          <div
            v-show="
              formData.aio_fixture_setting.aio_avoid_fixture ||
              engravSwitchCloseAlwaysShow
            "
          >
            <div class="item">
              <span id="span_p98poxozas" class="label">{{
                $translateLang('夹手长度(L)')
              }}</span>
              <div class="form-item">
                <a-input
                  @dragover="handleDragOver($event)"
                  v-model="formData.aio_fixture_setting.aio_fixture_length"
                  suffix="mm"
                />
              </div>
            </div>
            <div class="item">
              <span id="span_jy4qt8zjqr" class="label">{{
                $translateLang('夹手宽度(W)')
              }}</span>
              <div class="form-item">
                <a-input
                  @dragover="handleDragOver($event)"
                  v-model="formData.aio_fixture_setting.aio_fixture_width"
                  suffix="mm"
                />
              </div>
            </div>
            <div class="item">
              <span id="span_jl9fz74i9x" class="label">{{
                $translateLang('夹手1距边(H1)')
              }}</span>
              <div class="form-item">
                <a-input
                  @dragover="handleDragOver($event)"
                  v-model="
                    formData.aio_fixture_setting.aio_first_fixture_height
                  "
                  suffix="mm"
                />
              </div>
            </div>
            <div class="item">
              <span id="span_92mabu0joh" class="label">{{
                $translateLang('夹手2距边(H2)')
              }}</span>
              <div class="form-item">
                <a-input
                  @dragover="handleDragOver($event)"
                  v-model="
                    formData.aio_fixture_setting.aio_second_fixture_height
                  "
                  suffix="mm"
                />
              </div>
            </div>
            <div class="item">
              <span id="span_7em930l87b" class="label">{{
                $translateLang('夹手方向')
              }}</span>
              <div class="table-board-radio">
                <span
                  :class="{
                    'active-radio':
                      formData.aio_fixture_setting.aio_fixture_direction ===
                      item.value,
                  }"
                  class="ellipsis"
                  v-for="(item, index) in lavePoints"
                  :key="index"
                  @click="handeeChangeClamlHandPosition(item.value)"
                  :id="`engraving_setting_lavePoint_${index}_btn`"
                  >{{ $translateLang(item.label) }}</span
                >
              </div>
            </div>
            <!-- 示例图 -->
            <div class="example-img">
              <img
                :src="
                  require(`@/assets/image/clampHand${formData.aio_fixture_setting.aio_fixture_direction}.png`)
                "
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import { translate } from '@/util/commonFun'
import { buryPointApi, genUniId } from '@/util/commonFuncs'
import {
  regReplaceArcRadius,
  regReplaceAxisOffset,
  regReplaceBaseMaterialDefaultInputCheck,
  regReplaceCuttingDockInputCheck,
  regReplaceCuttingParamsDiameter,
} from '@/util/regReplace'
import DockFiveSixSample from '@/views/equipment/component/dockFiveSixSample.vue'

import DataTagPool from '../dataTagPool/src/data-tag-pool.vue'
import NewContent from '../newContent.vue'

// 夹手方向map映射
const clampHandDirectionMap = new Map([
  ['左侧', 'L'],
  ['右侧', 'R'],
  ['上侧', 'T'],
  ['下侧', 'B'],
])

export default {
  components: {
    DockFiveSixSample,
    NewContent,
    DataTagPool,
  },
  props: {
    obj: {
      type: Object,
      default: () => ({}),
    },
    knifeTypeOptions: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        enable_integration_device: false,
        yitiji_machine_name: 'xinhongtian',
        trimming_knife_diameter: 0,
        is_display_sample: false,
        anc_setting: {
          anc_begin_code: '',
          anc_end_code: '',
          knives: [],
        },
        process_anc_in_front: false,
        process_anc_in_back: false,
        has_anc_setting: false,
        aio_fixture_setting: {
          aio_avoid_fixture: false, // 避让一体机夹手
          aio_fixture_length: 0, //夹手长度
          aio_fixture_width: 0, // 夹手宽度
          aio_first_fixture_height: 0, // 夹手1距边(H1)
          aio_second_fixture_height: 0, // 夹手2距边(H2)
          aio_fixture_direction: clampHandDirectionMap.get('左侧'), // L 左 R 右 T 上 B 下
        },
        aio_clock_dir_switch: {
          enable: false,
          mill_hole_slot_dir: '顺时针',
          cut_internal_curve_dir: '顺时针',
        },
      },
      knives: [],

      aioOptions: [
        { label: '鑫宏天一体机', value: 'xinhongtian' },
        { label: '品脉一体机', value: 'pinmai' },
        { label: '锐诺一体机', value: 'ruinuo' },
        { label: '凯鸿一体机', value: 'kaihong' },
        { label: '极东一体机', value: 'jidong' },
        { label: '南兴菲达一体机', value: 'nanxingfeida' },
      ],
      knivesColumns: [
        // 编号
        {
          label: 'cuttingDock.knives.number',
          props: 'name',
          width: 70,
          isCheck: false,
        },
        // 刀直径Φ
        {
          label: 'cuttingDock.knives.diameter',
          props: 'diameter',
          width: 90,
          isCheck: false,
        },
        // 类型
        {
          label: 'cuttingDock.knives.type',
          props: 'type',
          width: 120,
          isCheck: false,
        },
        // 用途
        {
          label: 'cuttingDock.knives.use',
          props: 'use',
          width: 160,
          isCheck: false,
        },
        {
          label: 'cuttingDock.knives.axis_offset',
          props: 'axis_offset',
          width: 140,
          isCheck: true,
        },
        {
          label: 'cuttingDock.knives.arc_radius',
          props: 'arc_radius',
          width: 140,
          isCheck: true,
        },
        // Z轴快速移动速度
        {
          label: 'cuttingDock.knives.moveZF',
          props: 'moveZF',
          width: 150,
          isCheck: true,
        },
        // Z轴加工速度
        {
          label: 'cuttingDock.knives.cutZF',
          props: 'cutZF',
          width: 110,
          isCheck: true,
        },
        // XY轴快速移动速度
        {
          label: 'cuttingDock.knives.moveF',
          props: 'moveF',
          width: 150,
          isCheck: true,
        },
        // XY轴加工速度
        {
          label: 'cuttingDock.knives.cutF',
          props: 'cutF',
          width: 120,
          isCheck: true,
        },
        // X坐标偏移
        {
          label: 'cuttingDock.knives.xOffset1',
          props: 'xOffset',
          width: 100,
          isCheck: true,
        },
        // Y坐标偏移
        {
          label: 'cuttingDock.knives.yOffset1',
          props: 'yOffset',
          width: 100,
          isCheck: true,
        },
        // Z坐标偏移
        {
          label: 'cuttingDock.knives.zOffset1',
          props: 'zOffset',
          width: 100,
          isCheck: true,
        },
        // 换刀开始代码
        {
          label: 'cuttingDock.knives.startCode',
          props: 'startCode',
          width: 120,
          isCheck: false,
        },
        // 换刀结束代码
        {
          label: 'cuttingDock.knives.stopCode',
          props: 'stopCode',
          width: 120,
          isCheck: false,
        },
      ],
      rowIndex: null,
      columnIndex: null,
      currentRow: {},
      modelSetting: {},
      fileType: '',
      lavePoints: [
        {
          label: '左侧',
          value: clampHandDirectionMap.get('左侧'),
        },
        {
          label: '右侧',
          value: clampHandDirectionMap.get('右侧'),
        },
        {
          label: '上侧',
          value: clampHandDirectionMap.get('上侧'),
        },
        {
          label: '下侧',
          value: clampHandDirectionMap.get('下侧'),
        },
      ],
      dropData: null,
      ancFileList: [],
      selectKey: '',
      selectedDomFileInfo: null,
      dragWord: null,
      isIrregularMillingPermission: false,
    }
  },
  watch: {
    obj: {
      handler() {
        const copyObj = JSON.parse(JSON.stringify(this.obj))
        if (!copyObj.hasOwnProperty('is_display_sample')) {
          copyObj.is_display_sample = false
        }
        copyObj.old_yitiji_machine_name = copyObj.yitiji_machine_name
        this.knives = copyObj.anc_setting.knives
        copyObj.anc_setting.knives = []
        copyObj.process_anc_in_front = false
        copyObj.process_anc_in_back = false
        this.formData = copyObj
        this.getOneMacSet()
      },
      deep: true,
    },
  },
  computed: {
    isDiameterShow() {
      return this.formData.yitiji_machine_name == 'ruinuo'
    },
    isJidong() {
      return this.formData.yitiji_machine_name == 'jidong'
    },
    engravSwitchCloseAlwaysShow() {
      return this.$store.state.preferencesSetting.setting
        .engravSwitchCloseAlwaysShow
    },
    computedKnivesColumns() {
      let knifeStoreConfigTemp = [...this.knivesColumns] // 创建副本避免直接修改原数组
      // 如果刀具库中所有刀具都没有类型为斜钻的,则不显示轴偏移和圆弧半径
      const hasObliqueDrill = Object.values(
        this.formData.anc_setting.knives
      ).some((item) => item.type && item.type.includes('obliqueDrill'))

      if (!hasObliqueDrill) {
        knifeStoreConfigTemp = knifeStoreConfigTemp.filter(
          (item) => !['axis_offset', 'arc_radius'].includes(item.props)
        )
      }
      return knifeStoreConfigTemp
    },
    tableKey() {
      const hasObliqueDrill = Object.values(
        this.formData.anc_setting.knives
      ).some((item) => item.type && item.type.includes('obliqueDrill'))
      return `${hasObliqueDrill}`
    },
  },
  methods: {
    // 获取nc自定义文件名的接口
    getNcCustomLabel() {
      this.$getByToken(
        '/get_electronic_saw_label',
        {
          label_class: 'anc_label',
        },
        (res) => {
          this.ancFileList = res.data.file_info || []
        }
      )
    },
    // 一体机刀具用途 有z扣一体机加工的用户才展示铣异形的开关
    handleIrregularMillingPermission(row) {
      this.$getByToken(
        '/user_permission',
        { permission_type: 'ZK_IN_AIO' },
        (res) => {
          if (res.status == 1) {
            this.isIrregularMillingPermission = res.data.enable
          }
        }
      )
    },
    handleDragOver(event) {
      event.preventDefault()
    },

    handleTextareaDrop($event, key) {
      if (key === 'anc_begin_code' || key === 'anc_end_code') {
        setTimeout(() => {
          // 将光标的结束位置赋值给起始位置, 取消拖动之后的选中问题
          $event.target.selectionStart = $event.target.selectionEnd
        })
        // 埋点
        buryPointApi('engraving', `drop_${key}`)
        this.selectedDomFileInfo = null
      }
    },
    selectChange(val) {
      if (this.selectedDomFileInfo) {
        let startIndex = this.selectedDomFileInfo.selectionStart
        let endIndex = this.selectedDomFileInfo.selectionEnd
        let str = this.formData.anc_setting[this.selectKey]
        let newStr = [...str]
        newStr.splice(startIndex, endIndex - startIndex, `${val}`)
        this.formData.anc_setting[this.selectKey] = newStr.join('')
        this.selectedDomFileInfo = null
      }
    },
    markTextareaSelection(event, key) {
      this.selectKey = key
      this.selectedDomFileInfo = event.target
    },
    handleInputChange() {
      this.formData.trimming_knife_diameter =
        regReplaceBaseMaterialDefaultInputCheck(
          this.formData.trimming_knife_diameter,
          'engraving'
        )
      this.formData.trimming_knife_diameter =
        this.formData.trimming_knife_diameter.indexOf('.') > 0
          ? this.formData.trimming_knife_diameter
              .split('.')[0]
              .substring(0, 2) +
            '.' +
            this.formData.trimming_knife_diameter.split('.')[1]
          : this.formData.trimming_knife_diameter.substring(0, 2)
      this.formData.trimming_knife_diameter =
        this.formData.trimming_knife_diameter - 0
    },
    // 获取所有一体机模板
    getAllAioMachineFile() {
      this.$getByToken('/aio/models', { from: 'user' }, (res) => {
        if (res.status == 1) {
          this.aioOptions = res.data.model_list.map((item) => ({
            ...item,
            label: item.model_name,
            value: item.aio_format,
          }))
        }
      })
    },
    // 获取指定一体机设置
    getOneMacSet(changeModel) {
      let knives = []
      let beginCode = ''
      let endCode = ''
      this.formData.anc_setting.knives = []
      if (
        ![
          'xinhongtian',
          'pinmai',
          'ruinuo',
          'kaihong',
          'jidong',
          'nanxingfeida',
        ].includes(this.formData.yitiji_machine_name)
      ) {
        this.$getByToken(
          `/aio/models/${this.formData.yitiji_machine_name}`,
          {},
          (res) => {
            if (res.status == 1) {
              this.formData.process_anc_in_front =
                res.data.model_setting.anc_setting.process_anc_in_front
              this.formData.process_anc_in_back =
                res.data.model_setting.anc_setting.process_anc_in_back
              this.modelSetting = res.data.model_setting
              this.fileType = this.formData.is_display_sample
                ? this.formData.yitiji_machine_name
                : ''
              // 后台anc设置开启 且不是切换模板即初始调用
              const { process_anc_in_front, process_anc_in_back } =
                res.data.model_setting.anc_setting
              const isFlag = process_anc_in_front || process_anc_in_back
              if (!changeModel && isFlag) {
                knives = this.knives
                beginCode = this.formData.anc_setting.anc_begin_code
                endCode = this.formData.anc_setting.anc_end_code
              }
              // 后台anc设置开启 且 切换模板 就用模板的默认设置
              if (isFlag && changeModel) {
                knives = res.data.model_setting.model_aio_knives
                beginCode = res.data.model_setting.anc_setting.anc_begin_code
                endCode = res.data.model_setting.anc_setting.anc_end_code
              }
              this.formData.anc_setting.anc_begin_code = beginCode
              this.formData.anc_setting.anc_end_code = endCode
              if (knives && Object.keys(knives).length) {
                let ss = [
                  'slotable',
                  'holeable',
                  'trim_able',
                  'irregular_milling',
                ]
                Object.keys(knives)?.forEach((key) => {
                  // 打孔 拉槽 修边 铣异形 复选框处理
                  let useArr = []
                  ss.forEach((s) => {
                    if (knives[key][s]) {
                      useArr.push(s)
                    }
                  })
                  this.formData.anc_setting.knives.push({
                    ...knives[key],
                    use: useArr,
                    webId:
                      knives[key]?.webId ||
                      (this.knives && this.knives[key]?.webId) ||
                      genUniId(),
                  })
                })
              }
            }
          }
        )
      } else {
        this.formData.anc_setting = {
          anc_begin_code: '',
          anc_end_code: '',
          knives: [],
        }
        this.formData.process_anc_in_front = false
        this.formData.process_anc_in_back = false
        this.fileType = this.formData.is_display_sample
          ? this.formData.yitiji_machine_name
          : ''
      }
    },
    // 切换一体机模板
    handleChangeOneMac() {
      this.getOneMacSet(true)
    },
    // 更改行样式
    changeStyle({ row, rowIndex }) {
      if (this.currentRow.index == rowIndex) {
        return {
          height: '54px',
          'border-top': '1px solid #EEEEEE',
          'font-size': '14px',
          color: '#000000',
          'font-weight': '400',
          background: 'rgba(24, 168, 199, 0.2)',
        }
      }
      return {
        height: '54px',
        'border-top': '1px solid #EEEEEE',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '400',
      }
    },
    // 更改单元格样式
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'id') {
        return 'padding-left: 16px'
      }
    },
    // 更改表头单元格样式
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'id') {
        return 'padding-left: 16px; box-sizing: border-box;background: #fafafa'
      }
      return 'background: #fafafa'
    },
    // 更改表头行样式
    headerRowStyle({ row, rowIndex }) {
      return {
        height: '54px',
        'font-size': '14px',
        color: '#000000',
        'font-weight': '500',
        'border-bottom': 'none',
      }
    },
    // 点击单元格切换成输入框
    cellClick(row, column, cell, event) {
      if (column.property == 'id' || column.property == 'desc') {
        return
      }
      this.rowIndex = row.index
      this.columnIndex = column.index
      if (column.property != 'use' && column.property != 'type') {
        this.$nextTick(() => {
          this.$refs['editInput'][0].focus()
        })
      }
    },
    // 修改表格中的值
    inputBlur(row, prop) {
      row['desc'] = row['name']
      this.rowIndex = -1
      this.columnIndex = -1
      // 失去焦点判断刀直径是否为0
      if (row['diameter'] === 0) {
        row['diameter'] = ''
      }
      if (row['diameter']) {
        row['diameter'] = Number(row['diameter'])
      }
      if (['startCode2', 'stopCode2'].includes(prop)) {
        buryPointApi(
          'equipment_dock',
          prop == 'startCode2' ? 'start_code2' : 'stop_code2'
        )
      }
    },
    // 添加刀具
    handleAddNewKnife() {
      this.formData.anc_setting.knives.push({
        name: '',
        diameter: '',
        type: 'mill',
        use: [],
        moveZF: '',
        cutZF: '',
        moveF: '',
        cutF: '',
        xOffset: '',
        yOffset: '',
        zOffset: '',
        startCode: '',
        stopCode: '',
        axis_offset: '',
        arc_radius: '',
        webId: genUniId(),
      })
      this.rowIndex = this.formData.anc_setting.knives.length - 1
      this.columnIndex = 0
      this.$nextTick(() => {
        this.$refs['editInput'][0].focus()
      })
    },
    // 删除刀具
    handleDeleteKnife() {
      this.formData.anc_setting.knives.splice(
        this.formData.anc_setting.knives.findIndex(
          (v) => v.index == this.currentRow.index
        ),
        1
      )
    },
    // 选中刀具
    choseKnife(row, column, event) {
      this.currentRow = row
    },
    //把每一行的索引加到行数据中
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //把每一列的索引加到列数据中
    tableCellClassName({ column, columnIndex }) {
      column.index = columnIndex
    },
    // 切换刀具类型
    handleChangeKnifeType(val, row) {
      if (val === 'dill') {
        row.axis_offset = ''
        row.arc_radius = ''
        row.slotable = false
        row.trim_able = false
        row.irregular_milling = false
        row.use = row.use.filter((item) => item == 'holeable')
      } else if (val.includes('stylingKnife')) {
        row.axis_offset = ''
        row.arc_radius = ''
        row.holeable = false
        row.slotable = false
        row.trim_able = false
        row.irregular_milling = false
        row.use = []
      } else if (val.includes('mill')) {
        row.axis_offset = ''
        row.arc_radius = ''
      } else if (val.includes('obliqueDrill')) {
        row.holeable = false
        row.slotable = false
        row.trim_able = false
        row.irregular_milling = false
        row.use = []
        buryPointApi('engraving', 'change_oblique_drill_type_knife')
      }
    },
    handleInputCheck(row, prop, flag) {
      row['desc'] = row['name']
      if (flag) {
        row[prop] = regReplaceCuttingDockInputCheck(row[prop])
      }
      // 刀径只能输入数字且不能为负数和0
      if (prop === 'diameter') {
        row[prop] = regReplaceCuttingParamsDiameter(row[prop])
      }
      // 轴偏移仅可输入数字、小数点、负号，保留3位整数2位小数
      if (prop === 'axis_offset') {
        row[prop] = regReplaceAxisOffset(row[prop])
      }
      // 圆弧半径仅可输入数字、小数点,保留3位整数2位小数
      if (prop === 'arc_radius') {
        row[prop] = regReplaceArcRadius(row[prop])
      }
    },
    /** 一体机设置部分翻译 */
    t(k) {
      return translate('cuttingDock.aioMachineSetting.' + k)
    },
    /** 切割机刀部分的翻译 */
    kt(k) {
      return translate('cuttingDock.knives.' + k)
    },
    // 夹手位置修改
    handeeChangeClamlHandPosition(val) {
      this.formData.aio_fixture_setting.aio_fixture_direction = val
    },
    // 修改夹手位置避让状态
    handleChangeclampHandStatus(val) {
      // 开启时添加埋点，记录开启人数
      if (val) {
        buryPoint({
          function_module: 'engraving',
          function_point: 'clampHandAvoid',
        })
      }
    },
    // 限制修边只能单选
    handleUseChange(row) {
      if (row.use.includes('trim_able')) {
        // 遍历刀库 some在true的时候跳出循环
        this.formData.anc_setting.knives.some((knifeRow) => {
          // 不是当前刀具行
          if (row !== knifeRow && knifeRow.use.includes('trim_able')) {
            knifeRow.use = knifeRow.use.filter((v) => v !== 'trim_able')
            // 因为之前没有修边这个字段，而且只能选择一个，所以修改第一个之后就可以结束循环了，不存在历史数据问题
            return true
          }
          return false
        })
      }
      if (row.use.includes('irregular_milling')) {
        this.formData.anc_setting.knives.some((knifeRow) => {
          if (row !== knifeRow && knifeRow.use.includes('irregular_milling')) {
            knifeRow.use = knifeRow.use.filter((v) => v !== 'irregular_milling')
            return true
          }
          return false
        })
      }
    },
  },
  mounted() {
    this.getAllAioMachineFile()
    this.getNcCustomLabel()
    this.handleIrregularMillingPermission()
  },
}
</script>

<style lang="less" scoped>
.aio-machine-setting {
  padding: 15px;
  // margin: 16px;
  background: #fff;
  .box {
    margin-bottom: 20px;
    display: flex;
    .title {
      margin-right: 15px;
    }
    .ant-input {
      width: 100px;
    }
    .label-title {
      width: 216px;
      text-align: right;
      margin-right: 10px;
    }
  }
  .main-table {
    box-sizing: border-box;
    /deep/.el-table {
      &::before {
        background: transparent;
      }
      .has-gutter tr {
        background-color: #fafafa;
      }
      .el-table__cell.gutter {
        background-color: rgb(250, 250, 250);
      }
      .hidden-columns {
        display: none;
      }
      .knives_type {
        .icon-revise-show {
          display: none;
        }
        &:hover .icon-revise-show {
          display: inline-block;
        }
      }
    }
  }
  .operation-btn {
    box-sizing: border-box;
    .danger-btn {
      color: #ff4d4f;
      &.ant-btn {
        border-color: #ff4d4f;
      }
    }
  }
  .knife-purpose {
    display: flex;
    flex-wrap: wrap;
    /deep/.ant-checkbox-wrapper {
      margin-left: 0;
      &:nth-child(3) {
        margin-right: 8px;
      }
    }
    /deep/.ant-checkbox + span {
      padding-right: 0;
    }
  }
  .common-setting {
    .duck-clamp-hand {
      margin: 20px 0;
      padding-bottom: 20px;
      position: relative;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .label {
          width: 120px;
          text-align: right;
          margin-right: 5px;
          &::after {
            content: ':';
            color: #000;
          }
        }
        .table-board-radio {
          display: flex;

          span {
            display: inline-block;
            width: 74px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            border: 1px solid #d9d9d9;
            cursor: pointer;
            transition: all 0.5s;

            &:hover {
              z-index: 2;
              color: #18a8c7;
              border-color: #18a8c7;
            }

            &:nth-child(1) {
              margin-right: -1px;
              border-radius: 4px 0 0 4px;
            }

            &:nth-child(2) {
              margin-right: -1px;
            }

            &:nth-child(3) {
              margin-right: -1px;
            }

            &:nth-child(4) {
              border-radius: 0 4px 4px 0;
            }
          }

          .active-radio {
            z-index: 2;
            color: #18a8c7;
            border-color: #18a8c7;
          }
        }
      }
      .example-img {
        position: absolute;
        top: 50px;
        right: 50%;
      }
    }
  }
}
</style>
<style lang="less">
.aio-machine-setting {
  /deep/ .el-select-dropdown .el-popper {
    z-index: 1 !important;
  }
}
</style>
